import { BreadCrumb } from "app/core/interfaces/bread-crumb";
import { Form, FormProject } from "app/core/models/form";
import { Submission } from "app/core/models/submission";
import * as CommonActions from "../actions/common.actions";

export interface IState {
    inProgress: boolean;
    isMobileView: boolean;
    spinnersCount: number;
    showGridActions: string;
    submissions: Submission[];
    breadCrumbs: BreadCrumb[];
    selectedProject: FormProject;
    selectedForm: Form;
}

const initialState: IState = {
    inProgress: false,
    isMobileView: false,
    spinnersCount: 0,
    showGridActions: "",
    submissions: [],
    breadCrumbs: [],
    selectedProject: { id: "0", name: "All", code: "All" },
    selectedForm: { id: "0", title: "All" } as Form,
};

export const reducer = (
    state = initialState,
    action: CommonActions.CommonActions
): IState => {
    switch (action.type) {
        case CommonActions.CLEAR_SPINNER:
            return {
                ...state,
                spinnersCount: 0,
                inProgress: false,
            };

        case CommonActions.START_SPINNER:
            return {
                ...state,
                spinnersCount: state.spinnersCount + 1,
                inProgress: true,
            };

        case CommonActions.STOP_SPINNER:
            const spinnersCount = Math.max(0, state.spinnersCount - 1);
            return {
                ...state,
                spinnersCount,
                inProgress: spinnersCount > 0,
            };

        case CommonActions.SET_IS_MOBILE_VIEW:
            return {
                ...state,
                isMobileView: action.payload,
            };

        case CommonActions.SHOW_GRID_ACTIONS:
            return {
                ...state,
                showGridActions: action.payload,
            };

            break;

        case CommonActions.SET_SUBMISSIONS:
            return {
                ...state,
                submissions: action.payload,
            };

        case CommonActions.SET_BREADCRUMB:
            return {
                ...state,
                breadCrumbs: action.payload,
            };

            break;

        case CommonActions.SET_PROJECT:
            return {
                ...state,
                selectedProject: action.payload,
            };

        case CommonActions.SET_FORM:
            return {
                ...state,
                selectedForm: action.payload,
            };

        default:
            return state;
    }
};
